import Field from "@imminently/decisively-ui/Field";
import { useFormContext, useWatch } from "@imminently/decisively-ui/Form";
import GoalMenu from "@/pages/models/release/GoalMenu";
import { useParsedGraph } from "@/pages/models/release/GraphContext";

type GoalFieldProps = {
  name: string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
};

export const GoalField = ({ name, label, disabled, required }: GoalFieldProps) => {
  const form = useFormContext<any>();
  const graph = useParsedGraph();
  const value = useWatch({ control: form.control, name });

  return (
    <Field
      name={name}
      fullWidth
    >
      {label ? <Field.Label>{label}</Field.Label> : null}
      <Field.Control>
        <GoalMenu
          aria-labelledby={label}
          graph={graph}
          showIdentifiers={true}
          includeIdentifiers={true}
          goalId={typeof value === "string" ? value : ""}
          onGoalIdChange={(nextValue: string) =>
            form.setValue(name, nextValue, { shouldDirty: true, shouldTouch: true, shouldValidate: true })
          }
          allowEmpty
          disabled={disabled}
          required={required}
        />
      </Field.Control>
      <Field.Message />
    </Field>
  );
};
